var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScheduler(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 2C11.2761 2 11.5 2.17948 11.5 2.40039V3H12L12.2041 3.01074C13.2128 3.113 14 3.96435 14 5V12L13.9893 12.2041C13.8938 13.1457 13.1457 13.8938 12.2041 13.9893L12 14H4C2.96435 14 2.113 13.2128 2.01074 12.2041L2 12V5C2 3.89543 2.89543 3 4 3H4.5V2.40039C4.5 2.17948 4.72386 2 5 2C5.27614 2 5.5 2.17948 5.5 2.40039V3H7.5V2.40039C7.5 2.17948 7.72386 2 8 2C8.27614 2 8.5 2.17948 8.5 2.40039V3H10.5V2.40039C10.5 2.17948 10.7239 2 11 2ZM4 4C3.44772 4 3 4.44772 3 5V12C3 12.5523 3.44772 13 4 13H12C12.5523 13 13 12.5523 13 12V5C13 4.44772 12.5523 4 12 4H4Z",
    fill: "#002A69"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M11.5996 7C11.8205 7 12 7.17948 12 7.40039V11.5996C12 11.8205 11.8205 12 11.5996 12H10.4004C10.1795 12 10 11.8205 10 11.5996V7.40039C10 7.17948 10.1795 7 10.4004 7H11.5996ZM11.5996 5C11.8205 5 12 5.17948 12 5.40039V5.59961C12 5.82052 11.8205 6 11.5996 6H10.4004C10.1795 6 10 5.82052 10 5.59961V5.40039C10 5.17948 10.1795 5 10.4004 5H11.5996Z",
    fill: "#002A69"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M8.59961 7C8.82052 7 9 7.17948 9 7.40039V11.5996C9 11.8205 8.82052 12 8.59961 12H7.40039C7.17948 12 7 11.8205 7 11.5996V7.40039C7 7.17948 7.17948 7 7.40039 7H8.59961ZM8.59961 5C8.82052 5 9 5.17948 9 5.40039V5.59961C9 5.82052 8.82052 6 8.59961 6H7.40039C7.17948 6 7 5.82052 7 5.59961V5.40039C7 5.17948 7.17948 5 7.40039 5H8.59961Z",
    fill: "#002A69"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M5.59961 7C5.82052 7 6 7.17948 6 7.40039V11.5996C6 11.8205 5.82052 12 5.59961 12H4.40039C4.17948 12 4 11.8205 4 11.5996V7.40039C4 7.17948 4.17948 7 4.40039 7H5.59961ZM5.59961 5C5.82052 5 6 5.17948 6 5.40039V5.59961C6 5.82052 5.82052 6 5.59961 6H4.40039C4.17948 6 4 5.82052 4 5.59961V5.40039C4 5.17948 4.17948 5 4.40039 5H5.59961Z",
    fill: "#002A69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheduler);
export default __webpack_public_path__ + "static/media/Scheduler.7436d9201d0bb0ab7f3672930affef42.svg";
export { ForwardRef as ReactComponent };